/* eslint-disable no-undef */
import useApi from '../useApi';

export const useUploadAvatar = () => {
  const { data, error, loading, postData } = useApi('/BlazorApi/uploadAttachment');
  const { loading: multiLoading, postData: postMultiData } = useApi('/BlazorApi/uploadattachments');
  const { loading: singleLoading, postData: postSingleData } = useApi(
    '/BlazorApi/uploadsingleattachment',
  );

  const uploadAvatar = async (formBody) => {
    const response = await postData(formBody);
    return response;
  };

  const uploadAttachments = async (formBody) => {
    const response = await postMultiData(formBody);
    return response;
  };

  const uploadSingleAttachment = async (formBody) => {
    const response = await postSingleData(formBody);
    return response;
  };

  return {
    data,
    error,
    loading: loading || multiLoading || singleLoading,
    uploadAvatar,
    uploadAttachments,
    uploadSingleAttachment,
  };
};
